import _defineProperty from "/builds/speachme/speachmeDesktop/speach-front/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import { __decorate } from "tslib";
import { Component, Prop, Vue } from "vue-facing-decorator";
import axios from "axios";
import { Events } from "@/events/events";
const POLL_INTERVAL_MS = 8000;
let SpeachGenerationLoader = class SpeachGenerationLoader extends Vue {
  constructor(...args) {
    super(...args);
    _defineProperty(this, "speachId", void 0);
    _defineProperty(this, "courId", void 0);
    _defineProperty(this, "speachTotal", 0);
    _defineProperty(this, "speachDone", 0);
    _defineProperty(this, "inProgress", 0);
    // True once a generation was observed running, so we can detect the transition to "done".
    _defineProperty(this, "wasGenerating", false);
    _defineProperty(this, "pollTimer", null);
  }
  get progressPercent() {
    if (this.speachTotal <= 0) return 0;
    return Math.round(this.speachDone / this.speachTotal * 100);
  }
  mounted() {
    // Single initial check. The recurring poll is started only if a generation is actually
    // running (see fetchStatus) — opening the editor on a finished/normal speach must not poll.
    this.fetchStatus();
  }
  beforeDestroy() {
    this.stopPolling();
  }
  startPolling() {
    if (this.pollTimer !== null) return; // already running
    this.pollTimer = window.setInterval(() => this.fetchStatus(), POLL_INTERVAL_MS);
  }
  stopPolling() {
    if (this.pollTimer !== null) {
      window.clearInterval(this.pollTimer);
      this.pollTimer = null;
    }
  }
  async fetchStatus() {
    if (!this.speachId) return;
    try {
      const {
        data
      } = await axios.get('/recorder/aiSpeachGenerator/speachGenerationStatus', {
        params: {
          speachID: this.speachId
        }
      });
      this.speachTotal = data.speachTotal ?? 0;
      this.speachDone = data.speachDone ?? 0;
      this.inProgress = data.speachInProgress ?? 0;
      // Poll only while a generation is running; stop as soon as it is finished
      // (or when there was nothing to track in the first place).
      if (this.inProgress > 0) {
        this.wasGenerating = true;
        this.startPolling();
      } else {
        this.stopPolling();
        // Generation just finished while the editor was open: the legacy plan still holds the
        // pre-generation state, so clicking a freshly-generated chapter shows "no data". Ask the
        // legacy editor to refresh its plan. Fire once, only on the in-progress -> done transition.
        if (this.wasGenerating) {
          this.wasGenerating = false;
          this.refreshLegacyPlan();
        }
      }
    } catch (e) {
      // transient error — keep whatever polling state we had
      console.warn('speachGenerationStatus poll failed', e);
    }
  }
  /** Tell the legacy (jQuery) editor to reload the speach plan so the new chapters show their content. */
  refreshLegacyPlan() {
    try {
      if (typeof trig === 'function') {
        trig(Events.RAFRAICHIR_PLAN_COUR, this.courId);
      }
    } catch (e) {
      console.warn('RAFRAICHIR_PLAN_COUR trig failed', e);
    }
  }
};
__decorate([Prop({
  required: true
})], SpeachGenerationLoader.prototype, "speachId", void 0);
__decorate([Prop({
  default: ''
})], SpeachGenerationLoader.prototype, "courId", void 0);
SpeachGenerationLoader = __decorate([Component({})], SpeachGenerationLoader);
export default SpeachGenerationLoader;